import React, { useEffect, useState } from "react";
import { auth } from "./firebase";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "./firebase";

function GraderDashboardLayout({ children }) {
  const [reviewCount, setReviewCount] = useState(0);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      setEmail(user.email);
      fetchReviewCount(user.uid);  // Use UID instead of email for consistency
    }
  }, []);

  const fetchReviewCount = async (graderUid) => {
    try {
      const q = query(collection(db, "submissions"), where("status", "in", ["OPEN", "PENDING"]));
      const querySnapshot = await getDocs(q);
      let total = 0;

      querySnapshot.forEach((doc) => {
        const reviews = doc.data().reviews || [];
        if (reviews.some((r) => r.grader === graderUid)) {
          total++;
        }
      });

      setReviewCount(total);
    } catch (err) {
      console.error("Error fetching review count:", err.message);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
      }}>
        <div>
          <strong>{email}</strong><br />
          Reviews Completed: {reviewCount}
        </div>
        <button
          onClick={handleLogout}
          style={{
            padding: "8px 16px",
            backgroundColor: "#d32f2f",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </div>
      {children}
    </div>
  );
}

export default GraderDashboardLayout;
